import {select} from "redux-saga/effects"
import {waitForStateReady} from "../../functions";
import {accountsSelector} from "../selectors";

export function* getAccounts() {
    yield* waitForStateReady("accounting");
    return yield select(accountsSelector);
}
